import React, { useState } from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

import Utility, { deepClone } from "../../utility/Utility";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { DKSpinner,DKInput,INPUT_TYPE,INPUT_VIEW_DIRECTION,DKLabel } from "deskera-ui-library";
import AttendanceSettingApiService from "../../services/AttendanceSettingApiService";
import ApiConstants from "../../constants/ApiConstants";
import { Countries, COUNTRY, IN_STATES, US_STATES } from "../../constants/CountryConstant";
import { getStateListFromCountry } from "../../managers/common/CommonUtil";
export default function Places(props) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries: ["places"],
  });

  if (!isLoaded) return <DKSpinner className="pt-xxl pb-xxl" />;
  return <Map latLng={props.latLng} onSelect={(location)=>props.onSelectAddress(location)}/>;
}

const  Map=(props)=> {
  
  let makerList = props.latLng ?deepClone(props.latLng): [];
  const [zoomLevel, setZoomLevel] = useState(2);// initial zoom
  const [selected, setSelected] = useState(makerList);
  React.useEffect(() => {

    if (makerList && makerList.length == 0) {
      let address = getDefaultAddress()
      getDefaultLocation(`${address}`) 
    } else {
      setZoomLevel(14);
    }
  }, [])
  const getDefaultAddress = () => {
    let address = TenantService.get(TENANT.ADDRESS)
    let fullAddress = [];

    if (address && !Utility.isEmpty(address.country)) {
      let country = Countries.find(c => (c.value === address.country))
      if (country && country.label) {
        fullAddress.push(country.label)
        setZoomLevel(5);
      }
    }
    if (address && !Utility.isEmpty(address.state)) {
      let state = getStateListFromCountry().find(s => s.value === address.state);
      if (state && state.label) {
        fullAddress.push(state.label);
        setZoomLevel(7);
      }
    }
    if (address && !Utility.isEmpty(address.city)) {
      fullAddress.push(address.city)
      setZoomLevel(10);
    }
    return fullAddress.join(', ')
  }
  
  const getDefaultLocation = async (address) => {
    if(!Utility.isEmpty(address)) {
      const results = await getGeocode({ address });
      if(results) {
        const { lat, lng } = await getLatLng(results[0]);
      
        makerList = [{ lat: lat, lng: lng, address: address,placeId:results[0].place_id }]
        setSelected(makerList)
        props.onSelect(makerList)
      }
    } else {
      return Promise.resolve()
    }
    
  };
  const onSetSelect=(data)=> {
    let selectedList = selected ? deepClone(selected) : []
    selectedList=[data]// For multiple push data into selectedList
    setSelected(selectedList)
    props.onSelect(selectedList)
  }
  const onGoogleMapClick =  (data) =>{
    let latLng = {
      lat: data.latLng.lat(),
      lng: data.latLng.lng(),
      address: "",
      placeId:''
    }
    onSetSelect(latLng)
    AttendanceSettingApiService.getAddressFromLatLng({"lat":data.latLng.lat().toString(), "long":data.latLng.lng().toString()}).then(res=>{
      if(res) {
        let address = (res.results && res.results.length !=0 ) ? res.results[0].formatted_address: "";
        let placeId = (res.results && res.results.length !=0 ) ? res.results[0].place_id: "";
        let latLng = {
          lat: data.latLng.lat(),
          lng: data.latLng.lng(),
          address: address,
          placeId: placeId
        }
        onSetSelect(latLng)
      }
    })
  }

  return (
    <>
      <div className="places-container">
        <PlacesAutocomplete setSelected={(data)=>onSetSelect(data)} />
      </div>

      <GoogleMap
        zoom={zoomLevel} // zoom level 14=initial, 5=country, 7=state
        center={selected && selected.length!=0?selected[0]:{lat:0,lng:0}}
        mapContainerClassName="map-container"
        onClick={(data)=>onGoogleMapClick(data)}
      >
        {selected && selected.map(s=>{return <Marker position={s} />})}
        
      </GoogleMap>
    </>
  );
}

const PlacesAutocomplete = ({ setSelected }) => {
  const [searchField,setSearchField] = useState(null)
  const handleSelect = async (address) => {

    const results = await getGeocode({ address });
    const { lat, lng } = await getLatLng(results[0]);
    const {place_id} = results[0]
    setSelected({ lat, lng, address,placeId:place_id });
  };
  const getAutocompleteData = () =>{
    return []
  }
  const onSelectAddress = (a,b) =>{
    
    handleSelect(b.label)
    setSearchField(b.label)
  }
  const getAddressSearchField=()=> {
    return (
      <div className="parent-width">
        <DKInput
          title={""}
          type={INPUT_TYPE.DROPDOWN}
          direction={INPUT_VIEW_DIRECTION.VERTICAL}
          dropdownConfig={{
            allowSearch: true,
            data: getAutocompleteData(searchField),
            searchApiConfig: {
              method: "GET",
              getUrl: (searchText) => {
                return ApiConstants.URL.BASE
                  + ApiConstants.URL.COMPLIANCE.US.SEARCH_ADDRESS
                  + `?searchText=${searchText}`
              },
              dataParser: (response) => response
            },
            renderer: (index, item) => item.label,
            onSelect: (index, value) => {
              onSelectAddress(index, value)
            }
          }}
          value={searchField}
          required={false}
          canValidate={false}
          onChange={() => { }}
        />
      </div>
    )
}
  return (   
    <>{getAddressSearchField()}</>
  );
};
